<script>
    import language from "../language/da_DK.json";
    import info from "../../package.json";
</script>

<section class="info-section">
    <h2>{language.contact}</h2>
    <span>{language.technicalSupport}</span>
    <a href="mailto:{language.email}">
    <div class="mail">
        <img src="/images/mail.svg" alt="mail icon">
            <span>{language.email}</span>
    </div>
    </a>

    <a href="tel:{language.phone}">
    <div class="phone">
        <img src="/images/phone.svg" alt="phone icon">
            <span>{language.phone}</span>
    </div>
    </a>

    <p>Version: {info.version}</p>

</section>

<style>

    h2 {
        text-align: center;
        font-weight: 500;
        line-height: 1.5625rem;
        font-size: 1.375rem;
        letter-spacing: 0;
    }

    section > span {
        display: block;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0;
    }

    a:link {
        color: var(--color-black);
        text-decoration: none;
    }

    a:link:hover {
        color: var(--main-secondary-color);
        text-decoration: underline;
    }

    p{
        position: absolute;
        bottom: 8px;
        right: 1rem;
        margin-bottom: 0;
        padding: 0;
    }

    .mail,
    .phone {
        display: flex;
        flex-direction: row;
        align-items: center;
        background: white;
        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.2);
        height: 52px;
        border-radius: 	0.3125rem;
        padding: 0.625rem 1.25rem 0.625rem 1.25rem;
    }

    .mail > img,
    .phone > img {
        margin-right: 0.3125rem;
    }

    .mail {
        margin-top: 1.25rem;
        margin-bottom: 1rem;
    }

    .phone {
        margin-top: 0.625rem;
    }

    img {
        float: left;
    }
</style>